const errorClassName = 'form__error';
const messagesDefault: string[] = ['The following errors occured on the form.'];
let messages: string[] = [];

export const announceErrors = (): void => {
  clearAnnounceErrors();
  const elements = document.getElementsByClassName(errorClassName);

  if (elements.length > 0) {
    for (let i = 0; i < elements.length; i++) {
      if (window.getComputedStyle(elements[i]).display !== 'none') {
        const errorMessage = elements[i].getAttribute('aria-label');
        if (errorMessage) {
          messages.push(errorMessage);
        }
      }
    }

    if (messages.length > 0) {
      messages = [...messagesDefault, ...messages];
      setAnnounceErrors(messages.join(' '));
      elements[0].parentElement?.scrollIntoView({ behavior: 'smooth' });
    }
  }
};

export const getErrorMessages = (): void => {
  setTimeout(() => {
    announceErrors();
  }, 100);
};

export const setAnnounceErrors = (message: string): void => {
  const ariaLiveEl = document.getElementById(
    'account-aria-live'
  ) as HTMLElement;
  ariaLiveEl.innerHTML = message;
};

export const clearAnnounceErrors = (): void => {
  const ariaLiveEl = document.getElementById(
    'account-aria-live'
  ) as HTMLElement;
  ariaLiveEl.innerHTML = '';
  messages = [];
};
